class WebSocketClient {
  constructor(url, options = {}) {
    console.log(url)
    this.url = 'wss://caapi.livescreenapp.com/api/stream?u=' + encodeURIComponent(url) ;
    this.reconnectInterval = options.reconnectInterval || 2000;
    this.maxReconnectInterval = options.maxReconnectInterval || 30000;
    this.maxAttempts = options.maxAttempts || 10;
    this.currentAttempt = 0;
    this.ws = null;
    this.isOnline = navigator.onLine;
    this.shouldReconnect = false;
    this.messageQueue = [];
    this.eventListeners = {};

    window.addEventListener('online', () => this.handleOnline());
    window.addEventListener('offline', () => this.handleOffline());
  }

  on(event, callback) {
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  emit(event, data) {
    if (this.eventListeners[event]) {
      this.eventListeners[event].forEach(callback => callback(data));
    }
  }

  handleOnline() {
    this.emit('online');
    this.isOnline = true;
    this.currentAttempt = 0;
    if (this.shouldReconnect) {
      this.connect();
    }
  }

  handleOffline() {
    this.emit('offline');
    this.isOnline = false;
  }

  setupEventListeners() {
    this.ws.addEventListener('open', (event) => {
      this.emit('open', event);
      this.flushMessageQueue();
      this.resetConnectionVars();
    });

    this.ws.addEventListener('message', (event) => {
      this.emit('message', JSON.parse(event.data));
    });

    this.ws.addEventListener('close', (event) => {
      this.emit('close', event);
      if (event.code === 401) {
        this.emit('unauthorized');
        return;
      }
      this.reconnect();
    });
    this.ws.addEventListener('unauthorized', (event) => {
      this.emit('error', event);
    });
    this.ws.addEventListener('error', (event) => {
      this.emit('error', event);
    });
  }

  connect() {
    this.shouldReconnect = true;
    if (this.isOnline && (this.maxAttempts === 0 || this.currentAttempt < this.maxAttempts)) {
      this.ws = new WebSocket(this.url);
      this.setupEventListeners();
    } else {
      this.emit('maxAttemptsReached');
    }
  }

  reconnect() {
    const jitter = Math.random() * 1000; // Random jitter between 0 and 1000 ms
    const nextInterval = Math.min(this.maxReconnectInterval, this.reconnectInterval * 2 + jitter);

    setTimeout(() => {
      this.currentAttempt++;
      this.connect();
    }, nextInterval);

    this.reconnectInterval = nextInterval;
  }

  sendMessage(message) {
    try {
      const data = JSON.stringify(message);
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        console.log('Sending message:', data);
        this.ws.send(data);
      } else {
        console.log('Adding message to queue:', data);
        this.messageQueue.push(data);
      }
    } catch (error) {
      this.emit('messageError', error);
      console.log('Error sending message:', error);
    }
  }

  flushMessageQueue() {
    while (this.messageQueue.length > 0) {
      const message = this.messageQueue.shift();
      try {
        this.ws.send(message);
      } catch (error) {
        this.emit('messageError', error);
      }
    }
  }

  resetConnectionVars() {
    this.reconnectInterval = 2000;
    this.currentAttempt = 0;
  }
}

module.exports = WebSocketClient;
